import formatToDateType from './formatToDateType';

export default formatToDateType;
